module.exports = __webpack_public_path__ + "static/img/bg-fr.7f4bbd58.png";